import { UserDepartmentDetails } from 'adapters/types';
import { DropdownValue } from 'components/Dropdown/types';
import { STATUS, ERROR_TEXT } from '../dialogs/constants';
import { PrinterAndCheckNoResponseType } from './CheckSequence/types';
import { PrintChecksCIBDropdownType, PrintChecksVendorData } from './types';

export const createLabel = (accNum: string, accName: string): string =>
  `${accNum} - ${accName}`;

export const createCashInBankDropdownValue = (
  data: PrintChecksCIBDropdownType
): DropdownValue => ({
  label: createLabel(data.accountNumber, data.accountName),
  value: `${data.accountNumber}`,
  postingDescriptionRequired: data.postingDescriptionRequired
});

export const createCashInBankDropdownOptions = (
  data: PrintChecksCIBDropdownType[] | undefined
): DropdownValue[] | undefined =>
  data?.map(CIBAcc => createCashInBankDropdownValue(CIBAcc));

export const getPartiallyPrintedChecks = (
  status: string,
  errorText: string,
  errorType: string
): boolean => {
  const key = errorType as keyof typeof ERROR_TEXT;
  return (
    status === STATUS.PRINTED &&
    errorText.toLowerCase().includes(ERROR_TEXT[key])
  );
};

export const getReviewChecksTotal = (
  selectedVendors: PrintChecksVendorData[]
): number =>
  selectedVendors.reduce(
    (total, vendors) =>
      total + Number(vendors?.totalNetAmount?.split('$')[1] ?? 0),
    0
  );

export const printerLabel = (
  printerDetails: PrinterAndCheckNoResponseType | undefined
): string =>
  printerDetails?.printerDetails?.printerName
    ? `${printerDetails?.printerDetails?.printerName}, ${printerDetails?.printerDetails?.checkTray}`
    : '';

export const getSelectedDepartment = (
  deptIds: UserDepartmentDetails[] | undefined,
  cashCompanyStoreid: string
): UserDepartmentDetails | undefined =>
  deptIds?.find(department => department.storeId === cashCompanyStoreid);
